import * as auth from './types';

const mutations = {
  [auth.SET_ERROR](state, errors) {
    state.errors = errors;
  },
  [auth.SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
  },
  [auth.PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    //채팅내역삭제
    for (var i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key.indexOf('perce-chatroom-') >= 0) {
        localStorage.removeItem(key);
      }
    }
    // 동네설정 히스토리 삭제
    //2021-09-28 로그아웃시 삭제 제외
    //localStorage.removeItem('areaHistory');
    // notification token 삭제
    localStorage.removeItem('notificationToken');
  },
  [auth.SET_AUTH_REQ](state, data) {
    state.authReq = data;
  },
};

export default mutations;
